// window._ = require('lodash');

/**
 * We'll load jQuery and the Bootstrap jQuery plugin which provides support
 * for JavaScript based Bootstrap features such as modals and tabs. This
 * code may be modified to fit the specific needs of your application.
 */



try {
    // window.Popper = require('popper.js').default;
    window.$ = window.jQuery = require('jquery');

    require('bootstrap');
} catch (e) {}

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

window.axios = require('axios');

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

require('jquery-datetimepicker');

require('select-pure');
import SelectPure from "select-pure";
require('./grips.notification-0.1.0.js');


$(document).ready(function () {
    $('#candidate_birthdate').datetimepicker({
        i18n:{
            de:{
                months:[
                    'Januar','Februar','März','April',
                    'Mai','Juni','Juli','August',
                    'September','Oktober','November','Dezember',
                ],
                dayOfWeek:["Mo", "Di", "Mi", "So", "Do", "Fr", "Sa",
                ]
            }
        },
        timepicker:false,
        format:'d.m.Y'
    });


    let uploadArea = $('.upload-area');

    uploadArea.on('dragenter', function () {
        uploadArea.addClass('dragover');
    });

    uploadArea.on('dragleave', function () {
        uploadArea.removeClass('dragover');
    });

    $('#candidate_short_cv').on('change', function () {
        uploadArea.hide();
        $('#file-info').show();
        $('#filename').html($('#candidate_short_cv').val().replace(/^.*\\/, ""))
    });

    $('#remove-file').on('click', function () {
        $('#candidate_short_cv').val('')
        uploadArea.show();
        $('#file-info').hide();
    })

    var nationalityOptions = [{'value': 'DE', 'label': 'Deutschland'}];
    $.each(countries, function (k, v) {
        nationalityOptions.push({'label': v, 'value': k})
    })

    let nationalitySelect = new SelectPure('.candidate_nationality_multi_select', {
        options: nationalityOptions,
        autocomplete: true,
        onChange: value => {
            $('#candidate_nationality').val(value);
        }
    });

    let uniSelect = new SelectPure(".candidate_university_multi_select", {
        options: [
            {label: "Goethe Universität Frankfurt",value: "goethe",},
            {label: "Andere",value: "other"}
        ],
        icon: "la la-times",
        inlineIcon: false,
        onChange: value => {
            $('#candidate_university').val(value);

            if (value.indexOf('other') >= 0) {
                $('.candidate_university_other_wrapper').css({'display': 'flex'});
            } else {
                $('.candidate_university_other_wrapper').hide();
            }
        }
    });

    let deLangSelect = new SelectPure(".lang_de_select", {
        options: [
            {label: "Keine Kenntnisse", value: "A0"},
            {label: "A1 – Anfänger*in", value: "A1"},
            {label: "A2 – Grundlegende Kenntnisse", value: "A2"},
            {label: "B1 – Fortgeschrittene Sprachverwendung", value: "B1"},
            {label: "B2 – Selbstständige Sprachverwendung", value: "B2"},
            {label: "C1 – Fachkundige Sprachkenntnisse", value: "C1"},
            {label: "C2 – Annähernd muttersprachliche Kenntnisse", value: "C2"},
            {label: "Muttersprache", value: "M"},
        ],
        icon: "la la-times",
        inlineIcon: false,
        onChange: value => {
            $('#lang_de').val(value);
        }
    });

    let enLangSelect = new SelectPure(".lang_en_select", {
        options: [

            {label: "Keine Kenntnisse", value: "A0"},
            {label: "A1 – Anfänger*in", value: "A1"},
            {label: "A2 – Grundlegende Kenntnisse", value: "A2"},
            {label: "B1 – Fortgeschrittene Sprachverwendung", value: "B1"},
            {label: "B2 – Selbstständige Sprachverwendung", value: "B2"},
            {label: "C1 – Fachkundige Sprachkenntnisse", value: "C1"},
            {label: "C2 – Annähernd muttersprachliche Kenntnisse", value: "C2"},
            {label: "Muttersprache", value: "M"},
        ],
        icon: "la la-times",
        inlineIcon: false,
        onChange: value => {
            $('#lang_en').val(value);
        }
    });

    let facultySelect = new SelectPure(".candidate_faculty_multi_select", {
        options: [
            {value: "01", "label": '01 Rechtswissenschaft'},
            {value: "02", "label": '02 Wirtschaftswissenschaften'},
            {value: "03", "label": '03 Gesellschaftswissenschaften'},
            {value: "04", "label": '04 Erziehungswissenschaften'},
            {value: "05", "label": '05 Psychologie und Sportwissenschaften'},
            {value: "06", "label": '06 Evangelische Theologie'},
            {value: "07", "label": '07 Katholische Theologie'},
            {value: "08", "label": '08 Philosophie und Geschichtswissenschaften'},
            {value: "09", "label": '09 Sprach- und Kulturwissenschaften'},
            {value: "10", "label": '10 Neuere Philologien'},
            {value: "11", "label": '11 Geowissenschaften / Geographie'},
            {value: "12", "label": '12 Informatik und Mathematik'},
            {value: "13", "label": '13 Physik'},
            {value: "14", "label": '14 Biochemie, Chemie und Pharmazie'},
            {value: "15", "label": '15 Biowissenschaften'},
            {value: "16", "label": '16 Medizin'},
            {value: "99", "label": 'Sonstige'}
        ],
        icon: "la la-times",
        inlineIcon: false,
        onChange: value => {
            $('#candidate_faculty').val(value);
            if (value.indexOf('99') >= 0) {
                $('.candidate_faculty_other_wrapper').css({'display': 'flex'});
            } else {
                $('.candidate_faculty_other_wrapper').hide();
            }
        }
    });

    let degreeSelect = new SelectPure(".candidate_degree_multi_select", {
        options: [
            {value: "bachelor", label: 'Bachelor'},
            {value: "master", label: 'Master'},
            {value: "diploma", label: 'Diplom'},
            {value: "magister", label: 'Magister'},
            {value: "teaching", label: 'Lehramt Staatsexamen'},
            {value: "medical", label: 'Staatsexamen Medizin, Pharmazie'},
            {value: "jura", label: 'Staatsexamen Jura'},
            {value: "promotion", label: 'Promotion'},
            {value: "other", label: 'Sonstige'},
        ],
        icon: "la la-times",
        inlineIcon: false,
        onChange: value => {
            $('#candidate_degree').val(value);
            if (value.indexOf('other') >= 0) {
                $('.candidate_degree_other_wrapper').css({'display': 'flex'});
            } else {
                $('.candidate_degree_other_wrapper').hide();
            }
        }
    });

    let searchSelect = new SelectPure(".candidate_search_type_multi_select", {
        options: [
            {
                label: "Praktikumsplatz",
                value: "internship",
            },
            {
                label: "Trainee-Stelle",
                value: "trainee",
            },
            {
                label: "Einstiegsposition",
                value: "entry",
            },
            {
                label: "Werkstudententätigkeit",
                value: "student",
            },
            {
                label: "Sonstiges",
                value: "other",
            }
        ],
        multiple: true,
        icon: "la la-times",
        inlineIcon: false,
        onChange: value => {
            let candidateSearchType = $('#candidate_search_type');
            candidateSearchType.val(value);

            if (value.indexOf('other') >= 0) {
                $('.candidate_search_type_other_wrapper').css({'display': 'flex'});
            } else {
                $('.candidate_search_type_other_wrapper').hide();
            }
        }
    });

    var orgOptions = [];

    $.each(orgs, function (k, v) {
        orgOptions.push({'label': v.org_name, 'value': v.id.toString()})
    })

    let orgInstance = new SelectPure(".org_multi_select", {
        options: orgOptions,
        multiple: true,
        // default: false
        icon: "la la-times",
        inlineIcon: false,
        onChange: value => {
            let orgs = $('#orgs');
            orgs.val(value);
        }
    });

    $('.change').on('click', function (e) {
        e.preventDefault();
        $('.error').removeClass('error');

        if ($(this).hasClass('forward')) {
            validateSection($('.part').filter(':visible').attr('id'))
        }


        if ($('.error').length === 0) {
            $('.section').hide();
            $('#' + $(this).attr('data-target-id')).show();
        }
    })

    function validateSection(part) {
        let error = false;

        let reqFields = $('#' + part).find('input,select').filter('[required]');
        $.each(reqFields, function (k, v) {
            if ($(v).val().length === 0) {
                error = true;

                if ($(v).attr('data-source') !== undefined) {
                    $('.' + $(v).attr('data-source')).find('.select-pure__select').addClass('error');
                } else {
                    $('#' + $(v).attr('name')).addClass('error');
                }

                $('.bg-white').notification({
                    type: 'error',
                    title: 'Fehler',
                    message: 'Bitte füllen Sie alle Pflichtfelder aus',
                    autoClose: 4000
                });
            } else {
                if ($(v).attr('data-max') !== undefined) {
                    var valArray = $(v).val().split(',');
                    if (valArray.length > $(v).attr('data-max')) {
                        error = true;
                        $('.' + $(v).attr('data-source')).find('.select-pure__select').addClass('error');
                        $('.bg-white').notification({
                            type: 'error',
                            title: 'Fehler',
                            message: 'Sie dürfen maximal ' + $(v).attr('data-max') + ' Datensätze auswählen',
                            autoClose: 4000
                        });
                    }
                }
            }
        })

        return error;
    }


    $('#submit').on('click', function (e) {
        e.preventDefault();

        let error = validateSection($('.part').filter(':visible').attr('id'));

        if ($('#candidate_privacy').is(':checked')) {
            if ($('#submit').hasClass('disabled') === false) {

                $('#submit').html('<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>Anmelden');

                // $('#submit').addClass('disabled');

                $('.error').removeClass('error');
                let token = document.querySelector('meta[name="csrf-token"]').getAttribute('content');
                var form = $('#signup')[0];
                var formData = new FormData(form);
                // var imagefile = document.querySelector('#candidate_short_cv');
                // formData.append("candidate_short_cv", imagefile.files[0]);
                axios.post('/signup', formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                        "Accept": "application/json, text-plain, */*",
                        'X-Requested-With': 'XMLHttpRequest',
                        "X-CSRF-Token": token
                    }
                }).then(function (res) {
                    if (res.status === 200) {
                        let msgs = JSON.parse(res.data);
                        for (let i in msgs) {
                            if (msgs.hasOwnProperty(i)) {
                                for (let j in msgs[i]) {
                                    if (msgs[i].hasOwnProperty(j)) {
                                        $('#' + i).addClass('error');
                                        $('body').notification({
                                            type: 'error',
                                            title: 'Fehler',
                                            message: msgs[i][j],
                                            autoClose: 4000
                                        });
                                    }
                                }
                            }
                        }
                    } else if (res.status === 201) {
                        $('#finished').show();
                        $('#email').html($('input[name="candidate_email"]').val());
                        $('#signup-section').remove();
                    } else {
                        $('#submit').html('Anmelden');
                        $('#submit').removeData('disabled');
                        $('body').notification({
                            type: 'error',
                            title: 'Fehler',
                            message: 'Leider ist ein Fehler aufgetreten, bitte versuchen Sie es zu einem späteren Zeitpunkt erneut.',
                            autoClose: 4000
                        });
                    }
                }).catch(function (err) {
                    $('#submit').html('Anmelden');
                    $('#submit').removeData('disabled');
                    $('body').notification({
                        type: 'error',
                        title: 'Fehler',
                        message: 'Leider ist ein Fehler aufgetreten, bitte versuchen Sie es zu einem späteren Zeitpunkt erneut.',
                        autoClose: 4000
                    });
                });
            }
        } else {
            $('.bg-white').notification({
                type: 'error',
                title: 'Fehler',
                message: 'Bitte akzeptieren Sie die Datenschutzerklärung',
                autoClose: 4000
            });
        }
    });
})
